import * as types from 'modules/chat/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { getForeignInterventionId, getForeignInterventionType } from 'services/InterventionUtils';
import { createReducer } from 'utils/ReduxUtils';

export default createReducer(
  {},
  {
    [LOCATION_CHANGE]: () => ({}),
    [types.UNMOUNT_CONVERSATION_ATTACHMENTS_PANE]: () => ({}),
    [types.FETCH_CONVERSATION_ATTACHMENTS]: (_, { payload }) => {
      const { params } = payload.request;
      const entity = getForeignInterventionType(params);
      const entityId = getForeignInterventionId(params);

      return { ids: params.conversationIds?.split(',') ?? [], [`${entity}Id`]: entityId };
    },
  }
);
